export default {"src":"/_next/static/media/service-client.40a37eb5.svg","height":52,"width":65,"blurWidth":0,"blurHeight":0};